import { call, put, select, takeEvery } from 'redux-saga/effects';
import { safeSaga } from 'store';
import {
    SET_EMAIL_TEMPLATE,
    SYSTEM_EDIT_EMAIL_TEMPLATE,
    GET_EMAIL_TEMPLATE_LIST,
    UPDATE_EMAIL_TEMPLATE
} from 'store/key';
import { produce } from 'utility/general';
import api from 'api/call';
import { setGlobalLoading } from 'store/global/reducer';

const initialState = {
    emailTemplateList: []
};

function* getEmailTemplates(action) {
    try {
        yield put({
            type: SET_EMAIL_TEMPLATE,
            payload: {
                isLoading: true,
            },
        });

        const res = yield call(api.emailTemplate.getEmailTemplates, null);
        // console.log('res', res)
        const { result } = res.data;
        // console.log('res result', result)
        yield put({
            type: SET_EMAIL_TEMPLATE,
            payload: {
                emailTemplateList: result,
            },
        });
    } catch (error) {
        console.log('emailTemplate reducer.js error', error);
    }

    yield put({
        type: SET_EMAIL_TEMPLATE,
        payload: {
            isLoading: false,
        },
    });
}

function* editEmailTemplate(action) {
    const row = action.payload;
    const { emailTemplate: state } = yield select();
    let list = state.emailTemplateList;

    const index = list.findIndex((i) => i.id === row.id);
    state.emailTemplateList[index] = { ...row };
    yield put({
        type: SET_EMAIL_TEMPLATE,
        payload: state,
    });
}

function* updateEmailTemplate(action) {
    const { row, callback } = action.payload;

    setGlobalLoading(true);
    try {
        const res = yield call(api.emailTemplate.updateEmailTemplate, row);
        if (res.status === 200) {
            callback?.();
        }
    } catch (error) {
        console.log('emailTemplate reducer.js error', error);
    }
    setGlobalLoading(false);
}


const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_EMAIL_TEMPLATE:
            const newState = produce(state, (draft) => {
                Object.entries(action.payload).forEach(([key, value]) => {
                    draft[key] = action.payload[key];
                });
            });
            return newState;
        default:
            return state;
    }
};

export function* watchEditEmailTemplate() {
    yield takeEvery(SYSTEM_EDIT_EMAIL_TEMPLATE, safeSaga(editEmailTemplate));
    yield takeEvery(GET_EMAIL_TEMPLATE_LIST, safeSaga(getEmailTemplates));
    yield takeEvery(UPDATE_EMAIL_TEMPLATE, safeSaga(updateEmailTemplate));
}

export default reducer;
